import allFilesHaveUniqueNames from 'components/businessVerification/helpers/validateFiles';

import React, { useCallback, useState } from 'react';
import { useDropzone, DropzoneOptions, DropEvent } from 'react-dropzone';
import logger from './logger';
import { useSelector } from 'react-redux';
import { selectAppSettings } from 'reducers/appSettings';

export const useResetableDropzone = (
    options: DropzoneOptions = {},
    fieldName?: string,
    values?: any,
    setErrorMessage?: React.SetStateAction<any>,
    meta?: any,
    helpers?: any,
    jsonField?: boolean,
    saveFile?: (file: File[]) => Promise<boolean | void>
) => {
    const { businessVerificationFlow } = useSelector(selectAppSettings);
    const [isUploading, setIsUploading] = useState(false);
    const [acceptedFiles, setAcceptedFiles] = useState<File[]>([]);
    const onDropAccepted = useCallback(
        (files: File[], dropEvent: DropEvent) => {
            const handleSaveFile = async (files: File[], multi: boolean = false) => {
                if (saveFile) {
                    setIsUploading(true);
                    let saveSuccess = await saveFile(files); // Await the async operation
                    if (saveSuccess && !multi) {
                        helpers.setValue(files[0].name);
                        helpers.setTouched(true, false);
                        setAcceptedFiles(files);
                    } else if (saveSuccess && multi) {
                        let nextIndex = meta.value ? meta.value.length + 1 : 1;
                        const fieldFile = files.map((file) => ({
                            number: nextIndex,
                            fileName: file.name,
                        }));
                        meta.value
                            ? helpers.setValue([...meta.value, ...fieldFile])
                            : helpers.setValue([...fieldFile]);
                        helpers.setTouched(true, false);
                        setAcceptedFiles((curr) => [...curr, ...files]);
                    }
                    setIsUploading(false);
                    return saveSuccess;
                } else {
                    setIsUploading(false);
                }
                return false;
            };

            if (options.multiple) {
                if (jsonField && meta && helpers && fieldName && values) {
                    if (
                        allFilesHaveUniqueNames(
                            files,
                            values,
                            fieldName,
                            businessVerificationFlow,
                            Array.isArray(meta.value) ? meta.value : undefined
                        )
                    ) {
                        handleSaveFile(files, true);
                    } else {
                        setErrorMessage(
                            `${
                                files.length > 1 ? 'Files' : 'File'
                            } not accepted, file names must be unique.`
                        );
                    }
                } else if (meta && helpers) {
                    // setAcceptedFiles((curr) => [...curr, ...files]);
                    // let fieldValues = meta.value;
                    // let nextIndex = fieldValues ? fieldValues.length + 1 : 0;
                    // helpers.setValue([...acceptedFiles, ...files]);
                    // const fieldFile = files.map((file) => ({
                    //     number: nextIndex,
                    //     fileName: file.name,
                    //     //Add Id from response
                    // }));
                    // helpers.setValue([...fieldValues, ...fieldFile]);
                    logger.log("shouldn't hit");
                }
            } else {
                // setAcceptedFiles(files);
                if (jsonField && saveFile && helpers && fieldName && values) {
                    if (
                        allFilesHaveUniqueNames(files, values, fieldName, businessVerificationFlow)
                    ) {
                        setAcceptedFiles(files);
                        setErrorMessage('');
                        void handleSaveFile(files);
                    } else {
                        setErrorMessage(
                            'File name must be unique, this file has already been uploaded'
                        );
                    }
                } else {
                    if (
                        fieldName &&
                        values &&
                        allFilesHaveUniqueNames(files, values, fieldName, businessVerificationFlow)
                    ) {
                        setAcceptedFiles(files);
                        setErrorMessage('');
                        helpers?.setValue(files[0].name);
                        helpers?.setTouched(true, false);
                        void handleSaveFile(files);
                    } else {
                        setErrorMessage(
                            'File name must be unique, this file has already been uploaded'
                        );
                    }
                }
            }
            options.onDropAccepted && options.onDropAccepted(files, dropEvent);
        },
        [options]
    );
    const dropzoneValues = useDropzone({ ...options, onDropAccepted });

    const resetFiles = useCallback(() => {
        setAcceptedFiles([]);
        //fieldName && formik.setFieldValue(fieldName, options.multiple ? [] : null);
        helpers && helpers.setValue(null);
    }, [helpers]);

    return {
        ...dropzoneValues,
        acceptedFiles,
        resetFiles,
        setAcceptedFiles,
        isUploading,
    };
};
